import { render, staticRenderFns } from "./purchaseDetailsType4.vue?vue&type=template&id=45d55694&scoped=true"
import script from "./purchaseDetailsType4.vue?vue&type=script&lang=js"
export * from "./purchaseDetailsType4.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetailsType4.vue?vue&type=style&index=0&id=45d55694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d55694",
  null
  
)

export default component.exports